module.exports = "<nv-react-component component=\"MentoringRequest\"></nv-react-component>";